require('bootstrap');
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import Tooltip from 'vue-directive-tooltip';
import VueSlider from 'vue-slider-component';
import VuexRouterSync from 'vuex-router-sync';
import Inputmask from 'inputmask';
// import VueI18n from 'vue-i18n';
import VModal from 'vue-js-modal';
import Snotify from 'vue-snotify';
import App from './App.vue';
import router from './router/router';
import store from './store';
import jquery from 'jquery';

import 'vue-directive-tooltip/css/index.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'vue-select/dist/vue-select.css';
import 'vue-slider-component/theme/default.css';
import 'vue-snotify/styles/material.css';
import 'bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.min.css';
import './assets/styles/main.scss';

VuexRouterSync.sync(store, router);

/**
 * PLUGINS
 */

// InputMask
Vue.directive('input-mask', {
  bind: function (el) {
    new Inputmask().mask(el);
  },
});

// VueSlider
Vue.component('VueSlider', VueSlider);

// Tooltip
Vue.use(Tooltip, {
  delay: 0,
  placement: 'right',
  triggers: ['hover'],
  offset: 0
});

// Moment.js vue filter
Vue.use(require('vue-moment'));

// VueValidate
Vue.use(VeeValidate, { mode: 'lazy' });

// Snotify
Vue.use(Snotify, {
  toast: {
    timeout: 3000
  }
});

// VueI18n - disabled in this version
// Vue.use(VueI18n);
// const i18n = new VueI18n({
//   locale: 'en',
//   messages: {}
// });
// const i18n add to new vue instance
// example:
//  new Vue({
//    i18n,
//    router,
//    store,
//    render: h => h(App),
//  });

// Vue modal
Vue.use(VModal, { dialog: true });

/**
 * GLOBAL FUNCTIONS
 */
window.$ = jquery;
window.sanitizePercents = function (value) {
  let v = 0;
  if (value.replace('%', '') !== '') {
    v = parseInt(value.replace('%', ''));
    if (v > 100) {
      v = 100;
    }
  }
  return v;
};
window.sanitizeDoublePercents = function (value, cursorPosition) {
  const out = {
    postindustrial: 0,
    postconsumer: 0
  };

  const minusPos = value.indexOf('-');
  const splitted = value.split('-');
  splitted[0] = splitted[0].replace('%', '');
  if (typeof splitted[1] !== 'undefined') {
    splitted[1] = splitted[1].replace('%', '');
  }

  if (cursorPosition <= minusPos) {
    out.postindustrial = sanitizePercents(splitted[0]);
    out.postconsumer = 100 - out.postindustrial;
  }
  else {
    out.postconsumer = sanitizePercents(splitted[1]);
    out.postindustrial = 100 - out.postconsumer;
  }
  return out;
};
window.deepCopy = function (object) {
  return jquery.extend(true, {}, object);
};
window.objectToArray = function (object) {
  return Object.keys(object).map(function (key) { return object[key]; });
};

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
